
import stripeGateway from './checkout/stripe.js';
import mercadoPagoGateway from './checkout/mercadopago.js';
import paymentwall from './checkout/paymentwall.js';
import bankSlipMercadoPago from './checkout/bankSlipMercadoPago.js';
import coupon from './checkout/coupon.js';

import auth from './utils/auth.js';
import modal from './utils/modal.js';
import notyAlert from './utils/notyAlert.js';
import helperFunctions from './utils/functions.js';
import creditCard from './utils/creditCard.js';

import frontend from './frontend/frontend.js';

const card = stripeGateway.initialize('card-element');
initialize();

$(document).on('ready', function (e) {
    $("select[name=plan_id]").trigger('change');
});

/**
 * Submit Form Gateway Default
 */
$(document).on('submit', '#formGatewayDefault', function (e) {
    e.preventDefault();
    const form = $(this);
    const cardForm = getCardInForm(form);
    const type = form.data('type');
    let data = getData(form);

    modal.closeModal();
    modal.loadingModal('loading', 'Processing Payment');

    switch (type.toLowerCase().replace(" ", "")) {
        case 'stripe':
            stripeGateway.checkout(card, cardForm.cardholderName, function (token) {
                if (!token) {
                    return;
                }
                data.st_token = token;
                storeCheckout(data);
            });
            break;
        case 'stripebrazil':
            stripeGateway.checkout(card, cardForm.cardholderName, function (token) {
                if (!token) {
                    return;
                }
                data.st_token = token;
                storeCheckout(data);
            });
            break;
        case 'mercadopago':
            mercadoPagoGateway.initialize();
            mercadoPagoGateway.checkout(cardForm, function (response) {
                if (response.error) {
                    const msgErrors = mercadoPagoGateway.showErrorsCallbackInString(response);
                    modal.closeModal();
                    modal.errorModal('Oops', msgErrors);
                    return false;
                }
                data.mp_id = response.mp_id;
                data.mp_token = response.mp_token;
                storeCheckout(data);
            });
            break;
        case 'ebanxsubscription':
            data.card = cardForm;
            storeCheckout(data);
            break;

        case 'paymentwallsubscription':

            let brick = paymentwall.initialize();
            data.card = cardForm;

            paymentwall.tokenize(brick, cardForm, function (response) {
                storeCheckout(data);
            });

            break;

        case 'asaas':
            data.card = cardForm;
            storeCheckout(data);
            break;
        default:
            modal.closeModal();
            modal.errorModal('Oops', 'Internal Server Error');
    }

});

/**
 * Submit Form Bank Slip
 */
$(document).on('submit', '#formGatewayBankSlip', function (e) {
    e.preventDefault();

    modal.closeModal();
    modal.loadingModal('loading', 'Processing Payment');

    const form = $(this);
    const data = getData(form);
    const dataBankSlip = getDataBankSlip(form, data);

    if (!bankSlipMercadoPago.validate(dataBankSlip)) {
        modal.closeModal();
        return false;
    }

    storeCheckout(dataBankSlip);

});

/**
 * Submit Form Other forms
 */
$(document).on('submit', '#formGatewayOtherForms', function (e) {
    e.preventDefault();

    modal.closeModal();
    modal.loadingModal('loading', 'Processing Payment');

    const form = $(this);
    const data = getData(form);
    const document = $("input[name='other_forms[document]'");
    const phone = $("input[name='other_forms[mobile]'");

    if (document.length > 0 && !document.val()) {
        document.addClass('is-invalid');
        modal.closeModal();
        return false;
    }

    if (!phone.val()) {
        phone.addClass('is-invalid');
        modal.closeModal();
        return false;
    }

    document.removeClass('is-invalid');
    document.removeClass('is-invalid');
    data.document = document.val();
    data.phone = phone.val();
    data.gateway = $("select[name='other_forms[gateway]']").val();
    data.subscription = $("input[type=radio][name=mode]:checked").val() == 2
        ? 0
        : $("select[name='other_forms[gateway]'] option:selected").data('subscription')

    storeCheckout(data);
});

/**
 * Click in trial
 */
$(document).on('click', '.btn-order-now-free', function (e) {
    $(".step-3").hide();
    $(".step-4").hide();
    frontend.showRegister();
});

/**
 * click in advanced plans
 */
$(document).on('click', '.btn-order-now-advanced ', function (e) {
    $(".step-3").show();
    $(".step-4").show();
    frontend.showLogin();
});

/**
 * Click on any plan
 */
$(document).on('click', '.btn-order-now-advanced, .btn-order-now-free', function (e) {
    const divWithClassPopular = $(this).closest(".card-deck .card-pricing");
    const currentTotal = frontend.getTotalPrice();
    changeColorCardPlan(divWithClassPopular, currentTotal.reference);
});

/**
 * Change plan
 */
$(document).on('change', 'select[name=plan_id], select[name=plan_free_id]', function (e) {
    const currentTotal = frontend.getTotalPrice();
    const element = $(this).closest('.card-pricing');
    const divWithClassPopular = $(this).closest(".card-deck .card-pricing");
    changeColorCardPlan(divWithClassPopular, currentTotal.reference);
    frontend.setTotalPrice(currentTotal.total * currentTotal.amount, currentTotal.monthly, currentTotal.currency, element.find('.price'));
    frontend.setDiscount(currentTotal.economy, currentTotal.currency, currentTotal.label, element);
});

/**
 * Change on plan is activated (step 3)
 */
$(".form-checks").on('click', function () {
    frontend.checkCheckboxOnActivePlan($(this));
});


/**
 * Discount with coupon
 */
$(document).on('click', '.btn-apply-coupon', function (e) {
    const elementButton = $(this);
    const elementCode = elementButton.closest('div.row').find('input.coupon');
    const data = getData(elementButton.closest('form'));
    const code = elementCode.val();
    const plan = data.plan_id;

    if (!code) {
        elementCode.addClass('is-invalid');
        return false;
    }

    elementCode.removeClass('is-invalid');
    elementButton.find('i').show();
    elementButton.attr('disabled', 'disabled');

    coupon.check(code, plan, helperFunctions.getLangInUrl(), window._id, function (response) {
        elementButton.find('i').hide();
        elementButton.removeAttr('disabled');
        if (!response) {
            notyAlert.alert("Internal server error");
            modal.closeModal();
        } else if (response.success) {
            const currentTotal = frontend.getTotalPrice();
            const totalWithDiscount = currentTotal.total - (response.percentage / 100 * currentTotal.total);
            const element = elementButton.closest('form').find('.total-price span');
            frontend.setTotalPrice(totalWithDiscount * currentTotal.amount, 0, currentTotal.currency, element, true)


            notyAlert.alert(response.msg, "success");
            modal.closeModal();
        } else {
            notyAlert.alert(response.errors.join(', '));
            modal.closeModal()
        }
    });
});

/**
 * Login
 */
$(document).on('click', '.btn-login', function (e) {
    authenticate($(this));
});

/**
 * Register
 */
$(document).on('click', '.btn-register', function (e) {
    register($(this));
});

/**
 * Click in Don't have account
 */
$(document).on('click', '.dont-have-account', function (e) {
    frontend.showRegister();
})

/**
 * Change other forms
 */
$(document).on('change', 'select[name="other_forms[gateway]"]', function (e) {
    const form = $(this).closest('form');
    const data = getData(form);
    const buyKey = data.mode == 2
    frontend.changeOtherForms($(this), buyKey);
})

/**
 * Change amount of keys
 */
$(document).on('keyup', 'input[type=number][name=amount]', function (e) {
    const currentTotal = frontend.getTotalPrice();
    frontend.setTotalPrice(currentTotal.total * currentTotal.amount, currentTotal.monthly, currentTotal.currency);
});

/**
 * Get data post for api
 * @param {*} form
 */
function getData(form) {

    let data = {
        _id: window._id, // token gerado
        gateway: form.data('cart-id'), // vem no form
        plan_id: $("select[name=plan_id] option:selected").val(),
        subscription: form.data('subscription'),
        mode: $("input[type=radio][name=mode]:checked").val(),
        discount: $(form).find("input.coupon:first").val(), // gerar o cupom
    };

    if ($("input[type=radio][name=mode]:checked").val() == 2) {
        data.amount = $("input[name=amount]").val();
        data.subscription = 0;
    }

    return data;
}
/**
 * Get data post for api
 * @param {*} form
 * @param Object data
 */
function getDataBankSlip(form, data) {
    data.cep = form.find('input[name="invoice[zipcode]"]').val();
    data.com = "a";
    data.cpf = form.find('input[name="invoice[cpf]"]').val();
    data.first_name = form.find('input[name="invoice[first_name]"]').val();
    data.last_name = form.find('input[name="invoice[last_name]"]').val();

    return data;
}

/**
 * Store the checkout with token and data
 * @param string token 
 * @param object data 
 */
function storeCheckout(data) {

    //valid if is authenticated
    auth.isAuthenticated(function (response) {
        if (!response.authenticated) {
            modal.closeModal();
            $("input[name=login_email]").focus();
            modal.errorModal('Oops', response.message);
            return false;
        }

        $.post('/api/v2/checkout?lng=' + helperFunctions.getLangInUrl() + "&fp=" + data._id, data).then(function (response) {

            if (!response.success) {
                modal.closeModal();
                modal.errorModal(response.notification.title, response.notification.message);
                return false;
            } else {
                modal.closeModal();
                modal.successModal(response.notification.title, response.notification.message, true);
            }

            if (response.redirect !== null) {
                setTimeout(function () {
                    window.location = response.redirect;
                }, response.autoRedirect);
            }

        }, function (response) {
            modal.closeModal();
            modal.errorModal('error', 'Ops', 'An error occurred while checking out');
        }, 'json');
    })


}

/**
 * Login
 */
function authenticate(element = null) {

    let row = null;

    if (element != null) {
        element.find('i').show();
        element.attr('disabled', 'disabled');
        row = element.closest('.row');
    }

    modal.closeModal();
    modal.processingModal('Login', 'loading...');
    const email = $("input[name=login_email]").val();
    const password = $("input[name=login_password]").val();

    auth.login(email, password, function (response) {
        modal.closeModal();
        element.find('i').hide();
        element.removeAttr('disabled');

        if (!response) {
            notyAlert.alert("Internal server error", 'danger');
            return false;
        }

        if (!response.success) {
            notyAlert.alert(response.errors.join(', '), 'danger');
            return false;
        }

        notyAlert.alert(response.message, "success");
        if (row != null) {
            row.find('.col-md-5:nth-child(2)').remove();
            row.find('.col-md-2').remove();
            row.find('.col-md-5:first').removeClass('col-md-5').addClass('col-md-12');
            row.find('.col-md-12:first input').attr('disabled', 'disabled');
        }
    });

}

/**
 * Register
 */
function register(element = null) {

    modal.closeModal();
    modal.processingModal('Register', 'Register...');

    const email = $("input[name=register_email]").val();
    const password = $("input[name=register_password]").val();
    const passwordConfirm = $("input[name=register_confirm_password]").val();
    const redirectUrl = `${window.location.origin}/${window.location.pathname.split('/')[1]}/download`;

    if (!email) {
        $("input[name=register_email]").addClass('invalid');
        return false;
    }

    if (!password) {
        $("input[name=register_password]").addClass('invalid');
        return false;
    }

    if (!passwordConfirm) {
        $("input[name=register_confirm_password]").addClass('invalid');
        return false;
    }

    auth.register(email, password, passwordConfirm, function (response) {
        modal.closeModal();
        if (!response) {
            notyAlert.alert("Internal server error", 'danger');
            return false;
        }

        if (!response.success) {
            notyAlert.alert(response.errors.join(', '), 'danger');
            return false;
        }

        if (element != null) {
            // element.closest('.div-register').fadeOut();
            let div = element.closest('.div-register');
            div.find('.row:nth-child(4)').hide();
            div.find('.row:nth-child(3)').hide();
            div.find('.row:nth-child(2)').hide();
            div.find('.form-group.align-center').hide();
            div.find('.row:first .col-md-6:nth-child(2)').hide();
            div.find('.row:first .col-md-6:first').removeClass('col-md-6').addClass('col-md-12');
            div.find('.col-md-12:first input').attr('disabled', 'disabled');

        }
        if ($(".step-3").is(":visible")) {
            notyAlert.alert(response.message, "success");
        } else {
            modal.closeModal();
            modal.successModal('Success', response.long_message, redirectUrl);
            setTimeout(function () {
                window.location = redirectUrl;
            }, 5000)
        }
    });

}

/**
 * 
 * @param {*} form 
 */
function getCardInForm(form) {
    return {
        docType: form.find('input[name="checkout_default[typeDocument]"]').val(),
        docNumber: form.find('input[name="checkout_default[document]"]').val(),
        zipCode: form.find('input[name="checkout_default[zip_code]"]').val(),
        mobile: form.find('input[name="checkout_default[mobile]"]').val(),
        streetNumber: form.find('input[name="checkout_default[street_number]"]').val(),
        streetName: form.find('input[name="checkout_default[street_name]"]').val(),
        city: form.find('input[name="checkout_default[city]"]').val(),
        state: form.find('input[name="checkout_default[state]"]').val(),
        securityCode: form.find('input[name="checkout_default[ccv]"]').val(),
        cardExpirationYear: form.find('select[name="checkout_default[expiry_year]"]').val(),
        cardExpirationMonth: form.find('select[name="checkout_default[expiry_month]"]').val(),
        cardNumber: form.find('input[name="checkout_default[number]"]').val(),
        cardholderName: form.find('input[name="checkout_default[owner]"]').val(),
        cardBrand: creditCard.getBrand(form.find('input[name="checkout_default[number]"]').val())
    }
}

/**
 * Set value in global variable (id) for data checkouts
 * @return void
 */
function setIdFingerPrint() {
    new Fingerprint2({
        excludeAdBlock: true,
        excludeLanguage: true,
        excludeScreenResolution: true,
        excludeAvailableScreenResolution: true,
        excludeTimezoneOffset: true
    }).get(function (result, components) {
        window._id = result
    });
}

/**
 * Change for gold color - card plan - move to frontend.js
 * @param {*} divWithClassPopular 
 * @param {*} reference 
 */
function changeColorCardPlan(divWithClassPopular, reference) {
    const defaultPlan = divWithClassPopular.find('select[name=plan_id] option:selected').data('default');
    const spanReference = divWithClassPopular.find('span.span-reference');
    spanReference.html(`/ ${reference}`);
    let classCard = "popular";
    if (defaultPlan === 1) {
        $(this).addClass('btn-gold ');
        divWithClassPopular.find('span:first').addClass('bg-gold');
        divWithClassPopular.find('h1:first').addClass('wt-text-gold');
        divWithClassPopular.find('button').addClass('btn-gold');
        divWithClassPopular.find('.cart-ribbon').show();
        classCard = "gold";
    } else {
        divWithClassPopular.removeClass('gold');
        divWithClassPopular.find('span:first').removeClass('bg-gold');
        divWithClassPopular.find('h1:first').removeClass('wt-text-gold');
        divWithClassPopular.find('button').removeClass('btn-gold');
        divWithClassPopular.find('.cart-ribbon').hide();
    }
    frontend.changePlanIsActive(divWithClassPopular, classCard);
}


/**
 * Init
 */
function initialize() {
    setIdFingerPrint();
    const currentTotal = frontend.getTotalPrice();
    frontend.setTotalPrice(currentTotal.total * currentTotal.amount, currentTotal.monthly, currentTotal.currency);
    frontend.setMask();
}